<!--login-->
<template>
  <div class="login-box flex ac jb fs18">
    <div class="left-box">
      <img :src="login_bg" alt="">
    </div>
    <div class="right-box">
      <div class="login-form">
        <img class="login-logo-img" :src="login_logo" alt="">
        <p class="login-title">{{login_title}}</p>

        <div class="flex title-box cr mt10 mb10">
          <div class="login-pp" :class="loginState==1?'pp-active': ''" @click="changeLogin(1)">登录/</div>
          <div class="login-pp" :class="loginState==2?'pp-active': ''" @click="changeLogin(2)">兑换码激活注册</div>
        </div>

        <div v-if="loginState==1">
          <div class="login1 mt15 mb15">
            <el-input
              placeholder="用户名"
              prefix-icon="el-icon-s-custom"
              v-model="username">
            </el-input>
          </div>
          <div class="login2 mb15">
            <el-input
              placeholder="密码"
              prefix-icon="el-icon-lock"
              v-model="password"
              show-password
              @keyup.enter.native="handleLogin"
            >
            </el-input>

          </div>
        </div>

        <div v-if="loginState==2">
          <div class="login1 mt15 mb15">
            <el-input
              placeholder="注册手机号"
              prefix-icon="el-icon-s-custom"
              v-model="username2">
            </el-input>
          </div>
          <div class="login2 mb15">
            <el-input
              placeholder="密码"
              prefix-icon="el-icon-lock"
              v-model="password2"
              show-password
            >
            </el-input>

          </div>
          <div class="login1 mt15 mb15">
            <el-input
              placeholder="积分兑换码"
              prefix-icon="el-icon-c-scale-to-original"
              v-model="code">
            </el-input>
          </div>
        </div>

        <el-button type="primary" v-if="loginState==1" style="width: 100%;margin-top: 10px" @click="handleLogin">登录
        </el-button>
        <el-button type="primary" v-if="loginState==2" style="width: 100%;margin-top: 10px" @click="handleSign">
          兑换码激活注册
        </el-button>
        <div class="flex ac mt20 fs14" style="width: 130%">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
          <div style="color: #606266" v-if="eula&&privacy_agreement">
            <a style="color: #409EFF;cursor: pointer" :href="eula" target="_blank" rel="noreferrer">《用户协议》</a>
            <a style="color: #409EFF;cursor: pointer" :href="privacy_agreement" target="_blank" rel="noreferrer">《隐私条款》</a>与
            <span style="color: #409EFF;cursor: pointer" @click="goProtocol('creditsRule')">《付费协议》</span>
          </div>
          <div v-else style="color: #606266">
            <span style="color: #409EFF;cursor: pointer" @click="goProtocol('user')">《用户协议》</span>
            <span style="color: #409EFF;cursor: pointer" @click="goProtocol('privacy')">《隐私条款》</span>与
            <span style="color: #409EFF;cursor: pointer" @click="goProtocol('creditsRule')">《付费协议》</span>
          </div>
        </div>
        <div class="icp-box" v-if="beian"><a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">ICP备案号:{{beian}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import imgVerifyCom from '../components/MyImgVerify'//导入子组件
  import {employeeLogin, site, cdkey} from '../api/user'

  export default {
    name: '',
    components: {imgVerifyCom},//注册子组件
    data() {
      return {
        txText: '',
        username: '',
        password: '',
        login_bg: '',
        login_logo: '',
        login_title: '',
        checked: false,
        beian: '粤ICP备2024308983号-1',
        privacy_agreement: '',
        eula: '',
        loginState: 1,
        username2: '',
        password2: '',
        code: ''
      }
    },
    created() {
      this.loginState = this.$route.query.state ? this.$route.query.state : 1
      this.getSite()
      //   this.$refs.verifyRef.imgCode
    },
    methods: {
      changeLogin(val) {
        this.loginState = val
      },
      handleLogin() {
        if (!this.checked) {
          this.$message.error('请阅读并同意<<用户协议>>与<<隐私条款>>')
          return false
        }
        if (!this.username || !this.password) {
          this.$message.error('请输入账号密码')
          return false
        }
        employeeLogin({username: this.username, password: this.password, client: 'pc'}).then(res => {
          if (res && res.data.token) {
            this.$message.success('登录成功')
            window.localStorage.setItem('xcToken', res.data.token)
            if (this.redirectUrl) {
              setTimeout(() => {
                this.$router.replace({
                  path: this.redirectUrl
                })
              }, 800)
            } else {
              localStorage.setItem('navId', 0)
              setTimeout(() => {
                this.$router.push({
                  path: '/'
                })
              }, 800)
            }
          }
        }).catch(error => {
          this.$message.error(error.msg)
        })
      },
      // 激活码注册
      handleSign() {
        if (!this.checked) {
          this.$message.error('请阅读并同意<<用户协议>>与<<隐私条款>>')
          return false
        }
        if (!this.username2 || !this.password2) {
          this.$message.error('请输入账号密码')
          return false
        }
        if (!this.code) {
          this.$message.error('请输入兑换码')
          return false
        }
        cdkey({
          'code': this.code,
          'username': this.username2,
          'password': this.password2,
          'client': 'pc',
        }).then(res => {
          this.$message.success('您已成功兑换' + res.data.credits + '积分并注册成功')
          window.localStorage.setItem('xcToken', res.data.token)
          if (this.redirectUrl) {
            setTimeout(() => {
              this.$router.replace({
                path: this.redirectUrl
              })
            }, 800)
          } else {
            localStorage.setItem('navId', 0)
            setTimeout(() => {
              this.$router.push({
                path: '/'
              })
            }, 800)
          }
        }).catch(error => {
          this.$message.error(error.msg)
        })
      },
      // 获取配置
      getSite() {
        site().then(res => {
          this.beian = res.data.icp
          this.login_bg = res.data.login_bg ? res.data.login_bg : 'https://xcyq.oss-cn-qingdao.aliyuncs.com/8d/780ddfa11e8acc636d920c7e4ebd16.jpg'
          this.login_logo = res.data.login_logo ? res.data.login_logo : 'https://xcyq.oss-cn-qingdao.aliyuncs.com/59/e5f4618fd01cff923f4118f90552b8.png?attname=main-logo.png'
          this.login_title = res.data.login_title ? res.data.login_title : 'STARNEST ENGINE'
          this.privacy_agreement = res.data.privacy_agreement
          this.eula = res.data.eula
          const logo = res.data.logo
          if (logo) {
            window.onload = function () {
              var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
              link.type = 'image/x-icon';
              link.rel = 'shortcut icon';
              link.href = logo; // 将这里的地址替换为新的favicon地址
              document.getElementsByTagName('head')[0].appendChild(link);
            };
          }
        })
      },
      changeTitle() {
        site().then(res => {
          const title = res.data.title
          if (title) {
            document.title = title;
          }
        })
      },
      goUrl(val) {
        window.open(val)
      },
      goProtocol(val) {
        const routeData = this.$router.resolve({
          path: '/protocol',
          query: {
            type: val
          }
        });
        window.open(routeData.href, '_blank');
      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
      this.changeTitle()
    },
  }
</script>

<style lang="scss" scoped>
  .login-box {
    width: 100vw;
    height: 100vh;
    background-color: #ffffff;
  }

  .left-box {
    width: calc(100% - 700px);
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .right-box {
    position: relative;
    width: 700px;
    height: 100%;

    .login-form {
      width: 450px;
      background-color: #fff;
      /* border: 1px solid #e7e7e7; */
      border-radius: 4px;
      padding: 40px 50px;
      margin: 280px auto 0;

      .login-logo-img {
        width: 180px;
        height: 44px;
      }

      .login-title {
        font-size: 24px;
        font-weight: 700;
        margin: 10px 0;
      }

      .title-box {
        align-items: flex-end;

        .login-pp {
          font-weight: 500;
          font-size: 14px;
          color: #222222AA;
        }

        .pp-active {
          font-weight: 600;
          font-size: 18px;
          color: #222222;
        }
      }

      .icp-box {
        position: absolute;
        bottom: 15px;
        left: 0;
        width: 100%;
        font-size: 12px;
        text-align: center;
        color: #777;
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue